<template>
    <div class="com-list-wp">
         <div class="h-l-b">
                <div v-for="(item,index) in list" :key="index" class="item pointer" @click="getDetail(item)">
                    <el-row :gutter="10">
                        <el-col :span="1"><div class="circle"></div></el-col>
                        <el-col :span="20"><p class="pull-left p1">{{item.infoTitle}}</p></el-col>
                        <el-col :span="3"><p class="pull-right p2" style="width:100px;">{{item.createDate}}</p></el-col>
                    </el-row>
                        
                </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    props:{
        breadTitle:{
            default:'',
        },
        list:{
            default(){
                return[];
            }
        },
        returnType:{
            default:'id'
        }
    },
    methods:{
        getDetail(item){
            var val = this.returnType=='id'?item.id:item;
            this.$emit('getDetail',this.breadTitle,val);
        }
    }
}
</script>
<style lang="scss" scoped>
.com-list-wp{
    width:100%;
    height:auto;
}
.h-l-b{
        width:100% ;
        height:100%;
        padding-top: 10px;
        .item{
            width:100%;
            height:auto;
            border-bottom:1px solid #F5F4F7;
            p{
                
            }
            .circle{
                margin:14px 10px 0 20px;
                width:6px;
                height:6px;
                background:#656565;
                border-radius:50%;
                float: left;
            }
            .p1{
                color:#434343;
                margin-bottom: 20px;
                line-height: 30px;
            }
            .p1:hover{
                color:#0481F1;
            }
            .p2{
                color:#999999;
            }
        }
}
</style>